export enum Errors {
  LANDING_ALERTS_FETCH_ERROR_API_ERROR = 'Landing alerts - Fetch error - API error',
  LANDING_RESULTS_API_ERROR = 'Landing Results - API error',
}
